import React, { useState } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Text,
  Button,
  Select,
  Box
} from '@chakra-ui/react';
import { PhrasesType } from '../Table/MaintenancePhrasesTable';
import { UpdatePhrasesApi } from '../../../../apis/UpdateMaintenance.api';
import { CategroyNameType } from '../../../../apis/ApiClient';
import {
  BanInputType,
  CustomStringInput
} from '../../../atoms/CustomStringInput';

interface ResponseType {
  success: boolean;
  data: PhrasesType[] | CategroyNameType[] | null;
  message: unknown | null;
}

interface props {
  isOpen: boolean;
  onClose: () => void;
  EditData: PhrasesType | undefined;
  CategoryDatas: CategroyNameType[] | undefined;
  setMaintenanceDatas: React.Dispatch<
    React.SetStateAction<PhrasesType[] | undefined>
  >;
  CreateOrUpdateStateSwitch: () => void;
}

const InitTrainType = (
  editData: PhrasesType | undefined,
  CategoryDatas: CategroyNameType[] | undefined
) => {
  if (CategoryDatas === undefined) return;
  for (let i = 0; i < CategoryDatas?.length; i++) {
    if (CategoryDatas[i].category === editData?.category) {
      return CategoryDatas[i].id;
    }
  }
  return 1;
};

const GetPhrasesInputCheckData = (addData: string | undefined) => {
  if (addData === undefined) {
    return { Length: 300, BanInputType: BanInputType.None, Value: '' };
  }
  return { Length: 300, BanInputType: BanInputType.None, Value: addData };
};

const PhrasesEditWindow: React.FC<props> = (props) => {
  const {
    isOpen,
    onClose,
    EditData,
    CategoryDatas,
    setMaintenanceDatas,
    CreateOrUpdateStateSwitch
  } = props;
  const [categoryId, setCategoryId] = useState(
    InitTrainType(EditData, CategoryDatas)
  );
  const [phrases, setPhrases] = useState(EditData?.body);

  const PostApi = async () => {
    if (EditData !== undefined && EditData.id !== undefined) {
      const response: ResponseType = await UpdatePhrasesApi(EditData.id, {
        category_id: categoryId,
        body: phrases
      });
      if (response?.success === false) {
        alert('編集に失敗しました。');
        return;
      }
      setMaintenanceDatas(response.data as PhrasesType[]);
      CreateOrUpdateStateSwitch();
      onClose();
    }
  };

  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay />
        <ModalContent h='320px' maxW='1100px'>
          <ModalHeader
            textAlign='center'
            bg='gray.800'
            color='white'
            fontSize='16'
          >
            定型文を編集
          </ModalHeader>
          <ModalCloseButton color='white' />
          <ModalBody>
            <Box
              position='relative'
              display='grid'
              gridTemplateColumns='1fr 6fr'
            >
              <Text mt={4}>カテゴリ名</Text>
              <Select
                mt={2}
                w='100%'
                value={categoryId}
                onChange={(e) => setCategoryId(Number(e.target.value))}
              >
                {CategoryDatas?.map((data, i) => {
                  return (
                    <option key={'category' + i} value={data.id}>
                      {data.category}
                    </option>
                  );
                })}
              </Select>
              <Text mt={4}>定型文</Text>
              <CustomStringInput
                CheckInfo={GetPhrasesInputCheckData(EditData?.body?.toString())}
                inputValue={phrases}
                setValue={setPhrases}
                PhohibitionCharaCheck={false}
              />
            </Box>
            <Button mt={10} onClick={() => PostApi()}>
              更新
            </Button>
            <Button mt={10} ml={10} onClick={() => onClose()}>
              取り消す
            </Button>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};
export default React.memo(PhrasesEditWindow);
